/* Earthbound Q4 configurator — assets/q4-pdp.js (v4.15 — one variant per bed: pad.variants keyed by ID, pad.map bed → ID, pad.side = one-side ID)
 * Impact 6.12.0 · Rebuy Smart Cart v2 · Shopify Ajax Cart API
 * Upload check: this file must start with the line above. If Assets › q4-pdp.js starts with "{" or "<", the wrong file was pasted.
 *
 * DOM contract (rendered by sections/q4-buy-box.liquid):
 *   #q4-config                  <script type="application/json"> from snippets/q4-config.liquid
 *   #q4-beds   button[data-bed]                  bed-size cards (Twin, Twin XL, Full, Queen, King, Cal King)
 *   #q4-coverage  button[data-cov=whole|side]    coverage question (hidden until a coverage-eligible bed is chosen)
 *   #q4-cov-whole-price / #q4-cov-whole-compare
 *   #q4-pads   (hidden until a bed is chosen)    #q4-pads-list, select#q4-add-sel, button#q4-add-btn
 *   #q4-pad-price / #q4-pad-compare              price row under the title
 *   .q4-addon[data-addon=KEY]                    add-on card: input.q4-cbx[data-on], .q4-pills[data-pick=variant] button[data-id][data-price][data-compare][data-available]
 *                                                optional .q4-pills[data-pick=qty] button[data-qty] (pillow pair), .q4-head-price
 *   .q4-rodrow[data-addon=rod]                   compact add-on: input.q4-cbx, data-id/data-price on the row
 *   #q4-pay (static payment row, optional .q4-pay--sticky)
 *   #q4-bar-price (.q4-from) #q4-bar-total #q4-bar-compare #q4-bar-line #q4-atc #q4-open-sum #q4-err
 *   dialog#q4-dlg-sum  #q4-sum-rows
 * Everything else (size guide, research, testimonials dialogs, copy-code) is plain markup + [data-q4-open=ID] / [data-q4-close].
 */
(function () {
  'use strict';
  var cfgEl = document.getElementById('q4-config');
  if (!cfgEl) { console.error('[q4] #q4-config not found — is snippets/q4-config.liquid uploaded and rendered by q4-buy-box?'); return; }
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[q4] #q4-config is not valid JSON:', e.message, cfgEl.textContent.slice(0, 300)); return; }
  var $ = function (id) { return document.getElementById(id); };
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var setText = function (id, t) { var el = $(id); if (el) el.textContent = t; };
  var esc = function (t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  // ---------- money ----------
  var fmt = (function () {
    try { var nf = new Intl.NumberFormat(undefined, { style: 'currency', currency: CFG.currency || 'USD' }); return function (c) { return nf.format(c / 100); }; }
    catch (e) { return function (c) { return '$' + (c / 100).toFixed(2); }; }
  })();

  // ---------- state ----------
  var S = {
    bed: null, cov: 'whole', padQty: 1, extra: [],           // extra: [{key, qty}] from the add-another-size control
    addons: {},                                               // key -> {on, variantId, qty}
    claimed: false,                                           // shopper clicked Copy code (persisted for the session)
    cartCodes: [],                                            // codes already on the cart (coded link, popup, typed earlier)
    cart: null,                                               // the live cart (items added from other pages show in the summary)
    busy: false
  };
  var CLAIM_KEY = 'q4_code_claimed';
  try { S.claimed = !!CFG.discount.code && sessionStorage.getItem(CLAIM_KEY) === CFG.discount.code; } catch (e) {}
  function guard(name, fn) { try { fn(); } catch (e) { console.error('[q4] ' + name + ' failed:', e); } }
  function addonDefaultVariant(a) {
    var pick = a.defaultVariant ? a.variants.filter(function (v) { return v.id === a.defaultVariant && v.available; })[0] : null;   // editor-set default, if purchasable
    return pick || a.variants.filter(function (v) { return v.available; })[0] || a.variants[0];
  }
  CFG.addons.forEach(function (a) {
    var first = addonDefaultVariant(a);
    S.addons[a.key] = { on: false, variantId: first ? first.id : null, qty: a.defaultQty === 'pair' && a.pairOption ? 2 : 1, qtyTouched: false };
  });

  // ---------- pad helpers ----------
  function padVariantKey() {
    if (!S.bed) return null;
    var k = CFG.pad.map[S.bed];
    if (CFG.pad.coverage.indexOf(S.bed) !== -1 && S.cov === 'side') return CFG.pad.side;
    return k;
  }
  function padV(key) { return CFG.pad.variants[key]; }
  function hasCoverage() { return !!S.bed && !!CFG.pad.side && CFG.pad.coverage.indexOf(S.bed) !== -1; }   // no one-side pad on the product → no coverage question
  function covLabel() {                                                   // only beds with a coverage choice get a suffix
    if (hasCoverage()) return S.cov === 'side' ? CFG.text.oneSide : CFG.text.wholeBed;
    return '';                                                            // v4.13: was the pad variant's title ("Twin · Single / Half-Bed")
  }
  function selLabel() { var c = covLabel(); return S.bed + (c ? ' · ' + c : ''); }   // "Twin" / "Queen · Whole bed"
  function primaryKey() {                                                 // the add-another key that equals the main selection
    if (!S.bed) return null;
    if (hasCoverage() && S.cov === 'side') return 'side';
    var vid = CFG.pad.map[S.bed];
    for (var i = 0; i < CFG.extraSizes.length; i++) if (CFG.extraSizes[i].key !== 'side' && CFG.extraSizes[i].variant === vid) return CFG.extraSizes[i].key;
    return null;
  }
  function extraDef(key) { for (var i = 0; i < CFG.extraSizes.length; i++) if (CFG.extraSizes[i].key === key) return CFG.extraSizes[i]; return null; }
  function padLines() {
    var lines = [], k = padVariantKey();
    if (k && padV(k)) { var p = padV(k); lines.push({ id: 'p', vid: p.id, name: selLabel(), sub: p.title, price: p.price, compare: p.compare, qty: S.padQty }); }
    S.extra.forEach(function (x, i) { var d = extraDef(x.key), p = d && padV(d.variant); if (!p) return; lines.push({ id: String(i), vid: p.id, name: d.label, sub: d.sub, price: p.price, compare: p.compare, qty: x.qty }); });
    return lines;
  }
  function addonDef(key) { for (var i = 0; i < CFG.addons.length; i++) if (CFG.addons[i].key === key) return CFG.addons[i]; return null; }
  function addonVariant(key) { var d = addonDef(key), st = S.addons[key]; for (var i = 0; i < d.variants.length; i++) if (d.variants[i].id === st.variantId) return d.variants[i]; return null; }

  // ---------- rendering ----------
  function stepper(line) {
    return '<span class="q4-stepper"><button type="button" data-q="-1" data-line="' + line.id + '" aria-label="' + CFG.text.fewer + '"' + (line.id === 'p' && line.qty <= 1 ? ' disabled' : '') + '>−</button><output>' + line.qty + '</output><button type="button" data-q="1" data-line="' + line.id + '" aria-label="' + CFG.text.more + '"' + (line.qty >= CFG.maxQty ? ' disabled' : '') + '>+</button></span>';
  }
  function press(root, attr, val) { qsa('button[data-' + attr + ']', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset[attr] === val)); }); }

  function render() {
    var k = padVariantKey(), pad = k ? (padV(k) || null) : null, lines = padLines();
    // price row
    if ($('q4-pad-price')) $('q4-pad-price').textContent = pad ? fmt(pad.price) : CFG.text.from + ' ' + fmt(CFG.pad.minPrice);
    if ($('q4-pad-compare')) $('q4-pad-compare').textContent = fmt(pad ? pad.compare : CFG.pad.minCompare);
    // coverage prices
    if (hasCoverage()) { var whole = padV(CFG.pad.map[S.bed]); if (whole) { setText('q4-cov-whole-price', fmt(whole.price)); setText('q4-cov-whole-compare', fmt(whole.compare)); } }
    // availability: a sold-out pad size disables its bed card, its add-another-size option, and the one-side option
    if (beds) qsa('button[data-bed]', beds).forEach(function (b) { var pv = padV(CFG.pad.map[b.dataset.bed]); b.disabled = !(pv && pv.available); });
    if (cov) { var sv = CFG.pad.side ? padV(CFG.pad.side) : null; var sideBtn = qs('button[data-cov="side"]', cov); if (sideBtn) sideBtn.disabled = !(sv && sv.available); }
    if ($('q4-add-sel')) qsa('option[value]', $('q4-add-sel')).forEach(function (o) { if (!o.value) return; var d = extraDef(o.value), pv = d && padV(d.variant); o.disabled = !(pv && pv.available); });
    // pads list
    var padsq = $('q4-pads'); if (padsq) padsq.hidden = !S.bed;
    var lh = '';
    lines.forEach(function (l) {
      lh += '<div class="q4-prow"><div class="q4-pn"><b>' + l.name + '</b><small>' + l.sub + (l.qty > 1 ? ' · ' + fmt(l.price) + ' ' + CFG.text.each : '') + '</small></div>' +
        '<button type="button" class="q4-rm" data-rm="' + l.id + '" aria-label="' + CFG.text.remove + ' ' + l.name + '"><svg class="q4-i" aria-hidden="true"><use href="#q4-ic-x"/></svg></button>' +
        stepper(l) + '<div class="q4-pp"><s>' + fmt(l.compare * l.qty) + '</s>' + fmt(l.price * l.qty) + '</div></div>';
    });
    if ($('q4-pads-list')) $('q4-pads-list').innerHTML = lh;
    // add-on cards
    var addTotal = 0, bits = [];
    CFG.addons.forEach(function (a) {
      var st = S.addons[a.key], v = addonVariant(a.key), card = qs('[data-addon="' + a.key + '"]');
      if (!card) return;
      card.dataset.on = String(st.on);
      var cbx = qs('input.q4-cbx', card); if (cbx && cbx.checked !== st.on) cbx.checked = st.on;
      var head = qs('.q4-head-price', card); if (head && v) head.textContent = fmt(v.price * (st.on ? st.qty : 1));
      var vp = qs('.q4-pills[data-pick="variant"]', card); if (vp) press(vp, 'id', String(st.variantId));
      var qp = qs('.q4-pills[data-pick="qty"]', card);
      if (qp) { press(qp, 'qty', String(st.qty)); qsa('button[data-qty]', qp).forEach(function (b) { var q = parseInt(b.dataset.qty, 10), sm = qs('small', b); if (sm && v) sm.textContent = fmt(v.price * q) + (b.dataset.suffix ? ' ' + b.dataset.suffix : ''); }); }
      if (st.on && v) { addTotal += v.price * st.qty; bits.push((st.qty > 1 ? st.qty + ' × ' : '') + a.shortName); }
    });
    // bar
    var padTotal = 0, padCompare = 0, padCount = 0;
    lines.forEach(function (l) { padTotal += l.price * l.qty; padCompare += l.compare * l.qty; padCount += l.qty; });
    var bp = $('q4-bar-price'), from = bp ? qs('.q4-from', bp) : null;
    if (pad) {
      if (from) from.hidden = true;
      setText('q4-bar-total', fmt(padTotal + addTotal));
      setText('q4-bar-compare', fmt(padCompare + addTotal));
      var padBits = lines.map(function (l) { return (l.qty > 1 ? l.qty + ' × ' : '') + (l.id === 'p' ? selLabel() : (extraDef(S.extra[parseInt(l.id, 10)].key).shortLabel || l.name)); });
      setText('q4-bar-line', (padCount > 1 ? padCount + ' ' + CFG.text.pads + ' · ' : '') + padBits.join(' + ') + (bits.length ? ' · ' + bits.join(', ') : ' · ' + CFG.text.testKit));
      setText('q4-atc', CFG.text.addToCart);
    } else {
      if (from) from.hidden = false;
      setText('q4-bar-total', fmt(CFG.pad.minPrice + addTotal));
      setText('q4-bar-compare', fmt(CFG.pad.minCompare + addTotal));
      setText('q4-bar-line', bits.length ? CFG.text.chooseSize + ' · ' + bits.join(', ') : CFG.text.chooseSizePrice);
      setText('q4-atc', CFG.text.chooseSizeBtn);
    }
    // summary dialog rows
    var rows = '';
    var rx = function (attr, val, label) { return '<button type="button" class="q4-rx" ' + attr + '="' + val + '" aria-label="' + CFG.text.remove + ' ' + label + '"><svg class="q4-i" aria-hidden="true"><use href="#q4-ic-x"/></svg></button>'; };
    if (pad) lines.forEach(function (l) { rows += '<div class="q4-row"><div><div class="q4-ql">' + CFG.pad.title + ' ' + stepper(l) + '</div><small>' + l.name + (l.qty > 1 ? ' · ' + fmt(l.price) + ' ' + CFG.text.each : '') + '</small></div><div class="q4-r"><s>' + fmt(l.compare * l.qty) + '</s>' + fmt(l.price * l.qty) + ' <span class="q4-chip">' + CFG.text.chip + '</span></div>' + rx('data-rm', l.id, l.name) + '</div>'; });
    else rows += '<div class="q4-row"><div>' + CFG.pad.title + '<small>' + CFG.text.chooseSize + '</small></div><div class="q4-r">' + CFG.text.from + ' ' + fmt(CFG.pad.minPrice) + '</div></div>';
    CFG.addons.forEach(function (a) { var st = S.addons[a.key], v = addonVariant(a.key); if (st.on && v) rows += '<div class="q4-row"><div>' + a.title + (st.qty > 1 ? ' × ' + st.qty : '') + '<small>' + v.title + '</small></div><div class="q4-r">' + fmt(v.price * st.qty) + '</div>' + rx('data-rm-addon', a.key, a.title) + '</div>'; });
    // Items already in the cart (added from other pages) — listed under the page selection, removable, counted in the total.
    var cartItems = (S.cart && S.cart.items) || [], cartTotal = 0;
    if (cartItems.length) {
      rows += '<div class="q4-rows-sub">' + CFG.text.inCart + '</div>';
      cartItems.forEach(function (it) {
        cartTotal += it.original_line_price || it.line_price || 0;
        var name = esc(it.product_title || it.title || ''), vt = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) : '';
        rows += '<div class="q4-row q4-row--cart"><div>' + name + (it.quantity > 1 ? ' × ' + it.quantity : '') + (vt ? '<small>' + vt + '</small>' : '') + '</div><div class="q4-r">' + fmt(it.original_line_price || it.line_price || 0) + '</div>' + rx('data-rm-key', esc(it.key), name) + '</div>';
      });
    }
    var total = padTotal + addTotal + cartTotal, hasAnything = !!pad || cartItems.length > 0, discounted = hasAnything && offerOn() && claimed();
    // The code appears here only once the shopper has claimed it (Copy code) or the cart already carries it. Never offered here.
    if (discounted) rows += '<div class="q4-row q4-disc"><div>' + CFG.text.code + ' ' + CFG.discount.code + '<small>' + CFG.discount.note + '</small></div><div class="q4-r">−' + fmt(CFG.discount.amount) + '</div>' + (cartHasOurCode() ? '' : rx('data-q4-unclaim', '1', CFG.text.code + ' ' + CFG.discount.code)) + '</div>';
    else if (S.cart && S.cart.total_discount > 0) rows += '<div class="q4-row q4-disc"><div>' + CFG.text.cartDiscount + '</div><div class="q4-r">−' + fmt(S.cart.total_discount) + '</div></div>';   // their own code, already on the cart
    var shown = discounted ? Math.max(0, total - CFG.discount.amount) : (S.cart && S.cart.total_discount > 0 ? Math.max(0, total - S.cart.total_discount) : total);
    rows += '<div class="q4-row q4-total"><div>' + CFG.text.total + '</div><div class="q4-r">' + fmt(shown) + '</div></div>';
    if ($('q4-sum-rows')) $('q4-sum-rows').innerHTML = rows;
    if ($('q4-dlg-btn')) $('q4-dlg-btn').disabled = CFG.dlgAction === 'checkout' ? !hasAnything : !pad;
    if ($('q4-dlg-checkout')) $('q4-dlg-checkout').disabled = !hasAnything;   // page selection or items already in the cart
    if ($('q4-err')) $('q4-err').hidden = true;
    if ($('q4-dlg-err')) $('q4-dlg-err').hidden = true;
  }

  // ---------- interactions ----------
  var beds = $('q4-beds'), cov = $('q4-coverage');
  function setPadQty(q) { S.padQty = Math.min(CFG.maxQty, Math.max(1, q)); }
  // Preselected quantity per add-on (editor setting): one / pair / smart (pair for a whole Queen/King or Full bed, one for a half-bed).
  // Never overrides a quantity the shopper has tapped.
  function defaultPairQty() {
    CFG.addons.forEach(function (a) {
      if (!a.pairOption) return; var st = S.addons[a.key]; if (st.qtyTouched) return;
      if (a.defaultQty === 'pair') st.qty = 2;
      else if (a.defaultQty === 'smart') st.qty = (hasCoverage() && S.cov === 'whole') || /full|double/i.test(S.bed || '') ? 2 : 1;
      else st.qty = 1;
    });
  }
  function bedForVariant(v) { for (var k in CFG.pad.map) if (CFG.pad.map[k] === v) return k; return null; }
  function syncBedUI() {
    if (beds) press(beds, 'bed', S.bed || '');
    if (cov) press(cov, 'cov', S.cov);
    var cq = $('q4-coverage'); if (cq) cq.hidden = !hasCoverage();
  }
  // Removing the main pad line: the next added size (if any) becomes the main selection, otherwise the size step resets.
  function removePrimary() {
    if (S.extra.length) {
      var x = S.extra.shift(), d = extraDef(x.key);
      if (x.key === 'side') { S.bed = CFG.pad.coverage[0] || null; S.cov = 'side'; }
      else { S.bed = d ? bedForVariant(d.variant) : null; S.cov = 'whole'; }
      S.padQty = x.qty;
    } else { S.bed = null; S.cov = 'whole'; S.padQty = 1; }
    syncBedUI();
  }
  if (beds) beds.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-bed]'); if (!b) return;
    S.bed = b.dataset.bed; press(beds, 'bed', S.bed);
    var cq = $('q4-coverage');
    if (cq) { if (hasCoverage()) { if (cq.hidden) { cq.hidden = false; cq.classList.remove('q4-in'); void cq.offsetWidth; cq.classList.add('q4-in'); } } else cq.hidden = true; }
    defaultPairQty(); render();
  });
  if (cov) cov.addEventListener('click', function (e) { var b = e.target.closest('button[data-cov]'); if (!b) return; S.cov = b.dataset.cov; press(cov, 'cov', S.cov); defaultPairQty(); render(); });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-q][data-line]');
    if (b) {
      var d = parseInt(b.dataset.q, 10), ln = b.dataset.line;
      if (ln === 'p') setPadQty(S.padQty + d);
      else { var i = parseInt(ln, 10); if (S.extra[i]) { S.extra[i].qty = Math.min(CFG.maxQty, S.extra[i].qty + d); if (S.extra[i].qty <= 0) S.extra.splice(i, 1); } }
      render(); return;
    }
    var r = e.target.closest('button[data-rm]');
    if (r) { if (r.dataset.rm === 'p') removePrimary(); else S.extra.splice(parseInt(r.dataset.rm, 10), 1); render(); return; }
    var ra = e.target.closest('button[data-rm-addon]');
    if (ra && S.addons[ra.dataset.rmAddon]) { S.addons[ra.dataset.rmAddon].on = false; render(); return; }
    if (e.target.closest('[data-q4-unclaim]')) { claim(false); render(); return; }
    var rk = e.target.closest('button[data-rm-key]');
    if (rk) { removeCartLine(rk.dataset.rmKey); return; }
    var o = e.target.closest('[data-q4-open]');
    if (o) { var dlg = $(o.dataset.q4Open); if (dlg) { dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', ''); } return; }
    var c = e.target.closest('[data-q4-close]');
    if (c) { var dd = c.closest('dialog'); if (dd) dd.close(); }
  });
  qsa('dialog.q4-dlg').forEach(function (d) { d.addEventListener('click', function (e) { if (e.target === d) d.close(); }); });

  var addSel = $('q4-add-sel'), addBtn = $('q4-add-btn');
  if (addSel && CFG.extraSizes.length && addSel.options.length <= 1) {            // v4.15: options come from the config, so they always match the pad list
    CFG.extraSizes.forEach(function (x) { var p = padV(x.variant); if (!p) return; var o = document.createElement('option'); o.value = x.key; o.textContent = x.label + ' — ' + fmt(p.price); addSel.appendChild(o); });
  }
  if (addSel && addBtn) {
    addSel.addEventListener('change', function () { addBtn.disabled = !addSel.value; });
    addBtn.addEventListener('click', function () {
      var k = addSel.value; if (!k) return;
      if (k === primaryKey()) setPadQty(S.padQty + 1);
      else { var ex = null; S.extra.forEach(function (x) { if (x.key === k) ex = x; }); if (ex) ex.qty = Math.min(CFG.maxQty, ex.qty + 1); else S.extra.push({ key: k, qty: 1 }); }
      addSel.value = ''; addBtn.disabled = true; render();
      var last = $('q4-pads-list').lastElementChild; if (last) last.classList.add('q4-in');
    });
  }

  // add-on cards: checkbox, variant pills, qty pills
  qsa('[data-addon]').forEach(function (card) {
    var key = card.dataset.addon, st = S.addons[key]; if (!st) return;
    var cb = qs('input.q4-cbx', card); if (cb) cb.addEventListener('change', function () { st.on = cb.checked; render(); });
    card.addEventListener('click', function (e) {
      var v = e.target.closest('.q4-pills[data-pick="variant"] button[data-id]');
      if (v) { if (v.dataset.available === 'false') return; st.variantId = parseInt(v.dataset.id, 10); render(); return; }
      var q = e.target.closest('.q4-pills[data-pick="qty"] button[data-qty]');
      if (q) { st.qty = parseInt(q.dataset.qty, 10); st.qtyTouched = true; render(); }
    });
  });

  var copy = qs('[data-q4-copy]');
  if (copy) copy.addEventListener('click', function () {
    claim(true); render();                                    // clicking the code is the opt-in
    var t = copy.textContent;
    var done = function () { copy.textContent = CFG.text.copied; setTimeout(function () { copy.textContent = t; }, 1800); };
    var fallback = function () { copy.textContent = copy.dataset.q4Copy; };          // clipboard blocked: show the code itself
    try { if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(copy.dataset.q4Copy).then(done, fallback); else fallback(); } catch (err) { fallback(); }
  });

  // ---------- cart ----------
  function cartItems() {
    var map = {};
    padLines().forEach(function (l) { map[l.vid] = (map[l.vid] || 0) + l.qty; });
    CFG.addons.forEach(function (a) { var st = S.addons[a.key]; if (st.on && st.variantId) map[st.variantId] = (map[st.variantId] || 0) + st.qty; });
    return Object.keys(map).map(function (id) { return { id: parseInt(id, 10), quantity: map[id] }; });
  }
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var JSONH = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

  function showErr(msg, id) { var el = $(id || 'q4-err'); if (!el) { alert(msg); return; } el.textContent = msg; el.hidden = false; }

  // Offer code: one source of truth (CFG.discount from the section settings). Toggle, rename or re-price it in the theme editor.
  function offerOn() { return !!(CFG.discount.enabled && CFG.discount.code && CFG.discount.valid !== false); }
  // The discount is never assumed: it counts only once the shopper claims it (Copy code / Apply) or the cart already carries it.
  function cartHasAnyCode() { return S.cartCodes.length > 0; }
  function cartHasOurCode() { return S.cartCodes.indexOf(CFG.discount.code) !== -1; }
  function claimed() { return S.claimed || cartHasOurCode(); }
  function claim(on) { S.claimed = !!on; try { if (on) sessionStorage.setItem(CLAIM_KEY, CFG.discount.code); else sessionStorage.removeItem(CLAIM_KEY); } catch (e) {} }
  function noteCart(cart) { if (cart && cart.items) S.cart = cart; S.cartCodes = ((cart && cart.discount_codes) || []).map(function (d) { return String(d.code || '').toUpperCase(); }); return cart; }
  function tellTheme(cart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    var R = window.Rebuy; if (R && R.Cart && typeof R.Cart.setCart === 'function') { try { R.Cart.setCart(cart); } catch (e) {} }
    try { document.dispatchEvent(new CustomEvent('rebuy:cart.update', { detail: { cart: cart } })); } catch (e) {}
  }
  // × on an item that was already in the cart: Shopify change.js, then the header/Smart Cart are told
  async function removeCartLine(key) {
    try {
      var res = await fetch(ROOT + 'cart/change.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ id: key, quantity: 0 }) });
      if (!res.ok) throw new Error(CFG.text.addError);
      var cart = noteCart(await res.json()); tellTheme(cart); render();
    } catch (err) { showErr(err.message || CFG.text.addError, 'q4-dlg-err'); }
  }
  // After a successful add the page selection is cleared: the pads now live in the cart (and in the summary's cart list).
  function resetSelection() {
    S.bed = null; S.cov = 'whole'; S.padQty = 1; S.extra = [];
    CFG.addons.forEach(function (a) { var st = S.addons[a.key]; st.on = false; st.qty = a.defaultQty === 'pair' && a.pairOption ? 2 : 1; st.qtyTouched = false; st.variantId = (addonDefaultVariant(a) || {}).id || st.variantId; });
    syncBedUI();
  }
  function retireOffer() {
    CFG.discount.valid = false;
    qsa('[data-q4-offer]').forEach(function (el) { el.hidden = true; });
    render();
  }
  async function applyCode(cart) {
    noteCart(cart);
    if (!offerOn() || !CFG.discount.autoApply || !claimed()) return cart;        // only a claimed code is ever applied
    if (cart.discount_codes && cart.discount_codes.length) return cart;          // a code is already on this cart: leave it
    try {
      var up = await fetch(ROOT + 'cart/update.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ discount: CFG.discount.code }) });
      if (!up.ok) return cart;
      var next = noteCart(await up.json());
      var mine = (next.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === CFG.discount.code; })[0];
      if (mine && mine.applicable === false) retireOffer();                       // code expired or not valid for this cart: hide the badge, drop the line
      return next;
    } catch (e) { return cart; }
  }

  // Shared by the bar's Add to cart (→ Smart Cart) and the modal's Checkout (→ /checkout).
  // Resolves with the fresh cart, or throws with a readable message.
  async function addItems(btn, busyLabel) {
    var items = cartItems(); if (!items.length) throw new Error(CFG.text.addError);
    // 1. one request, every line
    var res = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ items: items }) });
    var data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || CFG.text.addError);
    // 2. optional: apply the page's claimed code only when the cart has none (never override a code the visitor arrived with)
    var cart = await applyCode(await (await fetch(ROOT + 'cart.js')).json());
    // 3. let Impact (header count) and Rebuy know, the same way the theme's own product form does
    tellTheme(cart);
    // 4. analytics context (Shopify's standard product_added_to_cart pixel event fires on its own for Ajax adds)
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'q4_configurator_add', items: items, value: cart.total_price / 100, currency: cart.currency }); } catch (e) {}
    return cart;
  }
  function goToSize() { var sz = $('q4-size') || beds; if (sz) sz.scrollIntoView({ behavior: 'smooth', block: 'start' }); setTimeout(function () { var f = beds && qs('button', beds); if (f) f.focus({ preventScroll: true }); }, 500); }
  function busy(btn, on) { if (!btn) return; if (on) { btn.dataset.label = btn.textContent; btn.setAttribute('aria-busy', 'true'); btn.textContent = CFG.text.adding; } else { btn.removeAttribute('aria-busy'); if (btn.dataset.label) btn.textContent = btn.dataset.label; } }

  function openCart() {
    // open the Rebuy Smart Cart (Product Form Redirect is "none" in your Rebuy config, so this is explicit)
    var R = window.Rebuy;
    if (R && R.SmartCart && typeof R.SmartCart.show === 'function') R.SmartCart.show();
    else if (CFG.openCart === 'redirect') window.location.href = ROOT + 'cart';
    else { var link = qs('a[href$="/cart"]'); if (link) link.click(); else window.location.href = ROOT + 'cart'; }
  }
  async function addToCart(btn, errId) {
    if (S.busy) return;
    if (!S.bed) { var d0 = $('q4-dlg-sum'); if (d0 && d0.open) d0.close(); goToSize(); return; }
    btn = btn || $('q4-atc'); S.busy = true; busy(btn, true);
    try {
      await addItems();
      var d = $('q4-dlg-sum'); if (d && d.open) d.close();      // modal closes, Smart Cart takes over
      resetSelection();
      openCart();
    } catch (err) {
      showErr(err.message || CFG.text.addError, errId);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      S.busy = false; busy(btn, false); render();
    }
  }

  // Modal button, "checkout" mode: add the page lines (if any), then straight to checkout. If the offer is claimed and the cart
  // carries no code yet, go through Shopify's /discount/CODE?redirect=/checkout so the code the modal shows is applied.
  async function checkout(btn) {
    if (S.busy) return;
    var hasCart = S.cart && S.cart.items && S.cart.items.length;
    if (!S.bed && !hasCart) { var d = $('q4-dlg-sum'); if (d && d.open) d.close(); goToSize(); return; }
    btn = btn || $('q4-dlg-checkout') || $('q4-dlg-btn'); S.busy = true; busy(btn, true);
    try {
      var cart = S.bed ? await addItems() : S.cart;
      var hasCode = cart.discount_codes && cart.discount_codes.length;
      if (offerOn() && claimed() && !hasCode) window.location.href = ROOT + 'discount/' + encodeURIComponent(CFG.discount.code) + '?redirect=' + encodeURIComponent(ROOT + 'checkout');
      else window.location.href = ROOT + 'checkout';                              // a code on the cart (coded link, popup) applies on its own
    } catch (err) {
      showErr(err.message || CFG.text.addError, 'q4-dlg-err');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      S.busy = false; busy(btn, false);
    }
  }
  var atc = $('q4-atc'); if (atc) atc.addEventListener('click', function () { addToCart(atc, 'q4-err'); });
  var dlgBtn = $('q4-dlg-btn'); if (dlgBtn) dlgBtn.addEventListener('click', function () { if (CFG.dlgAction === 'checkout') checkout(dlgBtn); else addToCart(dlgBtn, 'q4-dlg-err'); });
  var dlgCo = $('q4-dlg-checkout'); if (dlgCo) dlgCo.addEventListener('click', function () { checkout(dlgCo); });

  // ---------- count-up stats (vs section) ----------
  guard('count-up', function () {
    var stats = qsa('.q4-stat').filter(function (st) { return !!qs('.q4-num', st); }); if (!stats.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function run(st) {
      var num = qs('.q4-num', st), unit = qs('small', num), u = unit ? unit.outerHTML : '';
      var from = parseFloat(num.dataset.from), to = parseFloat(num.dataset.to), dec = parseInt(num.dataset.dec, 10);
      st.classList.add('q4-on');
      if (reduce) { num.innerHTML = to.toFixed(dec) + u; return; }
      var t0 = null, dur = 1600;
      function step(ts) { if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 3); num.innerHTML = (from + (to - from) * e).toFixed(dec) + u; if (k < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    }
    if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } }); }, { threshold: 0.4 }); stats.forEach(function (st) { io.observe(st); }); }
    else stats.forEach(run);
  });

  // ---------- sticky offset: follow the real header, re-measured on every scroll ----------
  // Earthbound's header (#eb-site-header, Section Store Header #14) is position:fixed below a 46px announcement bar, so its
  // bottom edge is 141px at the top of the page and 95px once the bar scrolls away, and on mobile it can hide on scroll.
  // Any fixed/sticky element near the top of the viewport that spans most of its width counts; the offset is its bottom edge.
  // v4.14: --q4-sticky-top (where the gallery sticks) still follows the header on every scroll, but the gallery HEIGHT is now
  // sized from --q4-gh-top = the header as it sits once the page is scrolled (CSS top + height), measured at load / resize only —
  // so the image no longer grows by the announcement bar's height as you scroll.
  guard('sticky offset', function () {
    var root = $('q4-pdp'); if (!root || root.dataset.stickyAuto === 'false') return;
    var cands = qsa('#eb-site-header, header, [class~="header"], [id*="header"], [class*="site-header"], [class*="announcement"]'), last = -1, lastStable = -1, raf = null;
    function headerBottom(stable) {
      var top = 0, vw = window.innerWidth;
      cands.forEach(function (el) {
        var cs = getComputedStyle(el); if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
        if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) === 0) return;
        var r = el.getBoundingClientRect();
        if (r.bottom <= 0 || r.top > 160 || r.width < vw * 0.6 || r.height < 24 || r.height > 260) return;
        var b = r.bottom;
        if (stable) { var ct = parseFloat(cs.top); b = (isNaN(ct) ? r.top : Math.max(0, ct)) + r.height; }
        if (b > top) top = b;
      });
      return Math.round(top);
    }
    function measure() { raf = null; var top = headerBottom(false); if (top !== last) { last = top; root.style.setProperty('--q4-sticky-top', top + 'px'); } }
    function measureStable(late) { if (late && window.scrollY > 4) return; var top = headerBottom(true); if (top && top !== lastStable) { lastStable = top; root.style.setProperty('--q4-gh-top', top + 'px'); } }
    function queue() { if (!raf) raf = requestAnimationFrame(measure); }
    measure(); measureStable(); setTimeout(measure, 600); setTimeout(measure, 1500);
    setTimeout(function () { measureStable(true); }, 600); setTimeout(function () { measureStable(true); }, 1500);
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', function () { queue(); measureStable(); });
    window.addEventListener('load', function () { measure(); measureStable(true); });
  });

  // ---------- pin to the header: the section's top edge meets the header's bottom edge exactly ----------
  // The theme and the fixed header leave their own (inconsistent) gap — larger on desktop, smaller than the header on
  // mobile, where the gallery slid underneath it. Measured at the top of the page; the section's own padding-top
  // ("Space below header") is then the whole visible gap.
  // v4.10: the gap is re-checked every time the page returns to the top (and whenever the header finishes animating),
  // not only at load. On mobile the header hides on the way down and slides back on the way up; it can also change
  // height after load. A reading is applied only when two readings 120 ms apart agree, so a header caught mid-slide
  // never sets the margin.
  guard('header flush', function () {
    var root = $('q4-pdp'); if (!root || root.dataset.flush === 'false') return;
    var applied = 0, tries = 0, pending = null, raf = null;
    var HDR = '#eb-site-header, header, [class~="header"], [id*="header"], [class*="site-header"], [class*="announcement"]';
    function headerBottom() {
      var top = 0, vw = window.innerWidth;
      qsa(HDR).forEach(function (el) {
        var cs = getComputedStyle(el); if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
        if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) === 0) return;
        var r = el.getBoundingClientRect(); if (r.bottom <= 0 || r.top > 160 || r.width < vw * 0.6 || r.height < 24 || r.height > 260) return;
        if (r.bottom > top) top = r.bottom;
      });
      return top;
    }
    function reading() {                                                // + : section is too high (under the header); − : too low (theme gap)
      if (window.scrollY > 4) return null;                               // only meaningful at the top of the page
      var hb = headerBottom(); if (!hb) return null;
      return Math.round(hb - root.getBoundingClientRect().top);
    }
    function settle(retry) {
      var d1 = reading(); if (d1 === null) return;
      clearTimeout(pending);
      pending = setTimeout(function () {
        var d2 = reading(); if (d2 === null) return;
        if (d2 !== d1) { if (!retry) settle(true); return; }             // header still moving: look once more a little later
        if (Math.abs(d2) < 1) return;
        applied += d2; root.style.marginTop = applied + 'px';
      }, retry ? 320 : 120);
    }
    function onScroll() { if (window.scrollY > 4) return; if (!raf) raf = requestAnimationFrame(function () { raf = null; settle(); }); }
    settle(); window.addEventListener('load', function () { settle(); });
    var iv = setInterval(function () { settle(); if (++tries > 6) clearInterval(iv); }, 300);  // header scripts settle late
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { settle(); });
    window.addEventListener('orientationchange', function () { setTimeout(settle, 350); });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', function () { settle(); });
    document.addEventListener('transitionend', function (e) {           // header show/hide or height animation finished
      var t = e.target; if (t && t.closest && t.closest(HDR)) settle();
    }, true);
  });

  // ---------- gallery: slider with arrows, dots (mobile) and a thumbnail strip (desktop) ----------
  guard('gallery', function () {
    var slides = $('q4-slides'), dots = $('q4-dots'), thumbs = $('q4-thumbs'), prev = $('q4-prev'), next = $('q4-next'), tprev = $('q4-tprev'), tnext = $('q4-tnext');
    if (!slides || !slides.children.length) return;
    var n = slides.children.length, cur = 0;
    if (dots) dots.innerHTML = ''; if (thumbs) thumbs.innerHTML = '';   // idempotent (theme editor re-renders)
    for (var i = 0; i < n; i++) {
      var slide = slides.children[i], img = qs('img', slide), src = slide.dataset.thumb || (img && (img.currentSrc || img.src));
      if (dots) { var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Photo ' + (i + 1)); d.dataset.i = i; dots.appendChild(d); }
      if (thumbs && src) { var t = document.createElement('button'); t.type = 'button'; t.setAttribute('role', 'tab'); t.setAttribute('aria-label', (slide.dataset.thumb ? 'Video ' : 'Photo ') + (i + 1)); t.dataset.i = i; if (slide.dataset.thumb) t.className = 'q4-vid'; var im = document.createElement('img'); im.src = src; im.alt = ''; im.loading = 'lazy'; t.appendChild(im); thumbs.appendChild(t); }
    }
    function padL() { return parseFloat(getComputedStyle(slides).scrollPaddingLeft) || 0; }
    function leftOf(i) { return slides.children[i].offsetLeft - padL(); }
    function nearest() { var x = slides.scrollLeft, best = 0, bd = Infinity; for (var j = 0; j < n; j++) { var d = Math.abs(leftOf(j) - x); if (d < bd) { bd = d; best = j; } } return best; }
    function go(i) { i = Math.max(0, Math.min(n - 1, i)); slides.scrollTo({ left: leftOf(i), behavior: 'smooth' }); }
    function mark(i) {
      cur = i;
      [dots, thumbs].forEach(function (g) { if (!g) return; Array.prototype.forEach.call(g.children, function (b, j) { b.setAttribute('aria-current', String(j === i)); }); });
      if (prev) prev.disabled = i <= 0; if (next) next.disabled = i >= n - 1;
      if (thumbs && thumbs.children[i]) {
        var t = thumbs.children[i];
        if (vertical()) { var tt = t.offsetTop - thumbs.offsetTop, tb = tt + t.offsetHeight; if (tt < thumbs.scrollTop) thumbs.scrollTo({ top: tt - 6 }); else if (tb > thumbs.scrollTop + thumbs.clientHeight) thumbs.scrollTo({ top: tb - thumbs.clientHeight + 6 }); }
        else { var tl = t.offsetLeft - thumbs.offsetLeft, tr = tl + t.offsetWidth; if (tl < thumbs.scrollLeft) thumbs.scrollTo({ left: tl - 6 }); else if (tr > thumbs.scrollLeft + thumbs.clientWidth) thumbs.scrollTo({ left: tr - thumbs.clientWidth + 6 }); }
      }
      syncThumbNav();
    }
    // thumbnail strip: vertical column on desktop, (hidden) row on mobile — nav buttons follow the axis
    function vertical() { return thumbs && getComputedStyle(thumbs).flexDirection === 'column'; }
    function syncThumbNav() {
      if (!thumbs || !tprev) return;
      var v = vertical(), max = (v ? thumbs.scrollHeight - thumbs.clientHeight : thumbs.scrollWidth - thumbs.clientWidth) - 1, pos = v ? thumbs.scrollTop : thumbs.scrollLeft;
      tprev.hidden = tnext.hidden = max <= 0; tprev.disabled = pos <= 0; tnext.disabled = pos >= max;
    }
    function nudge(dir) { if (!thumbs) return; var v = vertical(); thumbs.scrollBy(v ? { top: dir * thumbs.clientHeight * 0.8, behavior: 'smooth' } : { left: dir * thumbs.clientWidth * 0.8, behavior: 'smooth' }); }
    if (dots) dots.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) go(+b.dataset.i); });
    if (thumbs) { thumbs.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) go(+b.dataset.i); }); thumbs.addEventListener('scroll', syncThumbNav); }
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    if (tprev) tprev.addEventListener('click', function () { nudge(-1); });
    if (tnext) tnext.addEventListener('click', function () { nudge(1); });
    slides.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { go(cur + 1); e.preventDefault(); } if (e.key === 'ArrowLeft') { go(cur - 1); e.preventDefault(); } });
    var tick; slides.addEventListener('scroll', function () { clearTimeout(tick); tick = setTimeout(function () { mark(nearest()); }, 80); });
    window.addEventListener('resize', function () { slides.scrollTo({ left: leftOf(cur) }); syncThumbNav(); });
    mark(0); setTimeout(syncThumbNav, 300);
  });

  // ---------- bar: desktop two-state (sticky in column → fixed full-width once the column scrolls past) ----------
  guard('bar', function () {
    var bar = $('q4-bar'), col = $('q4-buy'), spacer = $('q4-bar-spacer'); if (!bar || !col) return;
    var mq = window.matchMedia('(min-width: 900px)'), fixed = false, raf = null;
    function apply(on) {
      if (on === fixed) return; fixed = on;
      if (on) { if (spacer) { spacer.style.height = bar.offsetHeight + 'px'; spacer.hidden = false; } bar.classList.add('q4-bar--fixed'); }
      else { bar.classList.remove('q4-bar--fixed'); if (spacer) spacer.hidden = true; }
    }
    function sync() {
      raf = null;
      if (!mq.matches) { apply(false); return; }
      var r = col.getBoundingClientRect();
      apply(r.bottom < window.innerHeight - 4);
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(sync); }
    window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll);
    sync(); setTimeout(sync, 600); window.addEventListener('load', sync);
  });

  // ---------- mobile bar: stays off-screen until the shopper has scrolled past the fold (setting: % of screen height) ----------
  guard('bar reveal', function () {
    var bar = $('q4-bar'), root = $('q4-pdp'); if (!bar || !root) return;
    var pct = parseFloat(root.dataset.barRevealM); if (!(pct > 0)) return;
    var mq = window.matchMedia('(max-width: 899px)'), raf = null, waiting = null;
    function sync() {
      raf = null;
      var wait = mq.matches && window.scrollY < window.innerHeight * pct / 100;
      if (wait === waiting) return; waiting = wait;
      bar.classList.toggle('q4-bar--wait', wait);
      if (!wait) bar.removeAttribute('aria-hidden'); else bar.setAttribute('aria-hidden', 'true');
    }
    function queue() { if (!raf) raf = requestAnimationFrame(sync); }
    sync(); window.addEventListener('scroll', queue, { passive: true }); window.addEventListener('resize', queue);
  });

  // ---------- proof strip: duplicate once for a seamless loop ----------
  var track = $('q4-proof-track'); if (track && !track.dataset.dup) { track.innerHTML += track.innerHTML; track.dataset.dup = '1'; }

  // ---------- init ----------
  if ($('q4-bar')) document.body.classList.add('q4-has-bar'); else console.warn('[q4] bar (#q4-bar) not on the page — is sections/q4-buy-box.liquid the current version?');
  try { defaultPairQty(); render(); } catch (e) { console.error('[q4] render failed:', e); }
  fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (cart) {
    if (!cart) return;
    noteCart(cart);
    if (offerOn() && CFG.discount.autoApply && claimed() && cart.item_count > 0) return applyCode(cart);
  }).then(function () { render(); }).catch(function () {});
  window.Q4PDP = { state: S, config: CFG, items: cartItems, render: render };
})();